<template>
  <section class>
    <div class="wrapper">
      <div class="content">
        <div class="jinNang-filter">
          <div class="filter-row">
            <div class="filter-row-type">
              <div class="filter-type-item">类型</div>
            </div>
            <div class="filter-row-content">
              <div
                v-for="(item, index) in riskList"
                :key="index"
                @click="riskSelect(item, index)"
                :class="{
                  'item-bottom-10': true,
                  'select-item': activeRisk == item.value,
                  'filter-item': true
                }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="filter-row">
            <div class="filter-row-type">
              <div class="filter-type-item">风格</div>
            </div>
            <div class="filter-row-content">
              <div
                v-for="(item, index) in styleList"
                :key="index"
                @click="styleSelect(item, index)"
                :class="{
                  'item-bottom-10': true,
                  'select-item': item.selected,
                  'filter-item': true
                }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="jinNang-list">
          <ul class="sort-key-tabs">
            <li
              class="sort-key-tab"
              v-for="(item, index) in sortKeyList"
              :key="index"
              :class="{
                'sort-key-tab--active': activeSortKey === index,
                ascending:
                  activeSortKey === index &&
                  item.direction === SortDirection.ascending,
                descending:
                  activeSortKey === index &&
                  item.direction === SortDirection.descending
              }"
              @click="changeSortKey(item, index)"
            >
              <span class="sort-key-name">
                {{ item.name }}
                <span class="caret-wrapper">
                  <span class="sort-caret ascending"></span>
                  <span class="sort-caret descending"></span>
                </span>
              </span>
            </li>
          </ul>
          <jinNang-list
            :list="jinNangList"
            :end="pageEnd"
            :sortType="sortKeyList[activeSortKey].type"
            @loadMore="getJinNangList"
          ></jinNang-list>
        </div>
      </div>
      <div class="right-panel">
        <star-author-panel :type="1" :title="title"></star-author-panel>
      </div>
    </div>
  </section>
</template>

<script>
import { getJinNangList } from '@/api/jinNangList'
import JinNangList from '@/components/JinNangList/JinNangList'
import StarAuthorPanel from '@/components/StarAuthorPanel/StarAuthorPanel'

// import BaseTabs from '@/components/BaseTabs/BaseTabs'

/**
 * 排序方向
 * @type {{ascending: number, descending: number}}
 */
const SortDirection = {
  /**
   * 无效
   */
  none: 0,
  /**
   * 升序
   */
  ascending: 1,
  /**
   * 降序
   */
  descending: 2
}

export default {
  name: 'JinNang',
  components: { JinNangList, StarAuthorPanel },
  data() {
    return {
      title: '热门实战大咖',
      SortDirection,
      styleList: [
        { name: '波段操作', value: 1, selected: false },
        { name: '中短线', value: 2, selected: false },
        { name: '中长线', value: 3, selected: false },
        { name: '基本面', value: 4, selected: false },
        { name: '趋势交易', value: 5, selected: false },
        { name: '量化投资', value: 6, selected: false },
        { name: '价值成长', value: 7, selected: false },
        { name: '热点题材', value: 8, selected: false },
        { name: '其它', value: 0, selected: false }
      ],
      riskList: [
        { name: '全部', value: null },
        { name: '稳健型', value: 1 },
        { name: '积极型', value: 2 },
        { name: '激进型', value: 3 }
      ],
      sortKeyList: [
        {
          name: '周收益',
          type: 2,
          direction: SortDirection.none
        },
        {
          name: '月收益',
          type: 3,
          direction: SortDirection.none
        },
        {
          name: '总收益',
          type: 0,
          direction: SortDirection.descending
        }
      ],
      activeStyle: null,
      activeRisk: null,
      activeSortKey: 2,
      jinNangList: [],
      viewState: '',
      pageEnd: true
    }
  },
  created() {
    this.getJinNangList()
  },
  methods: {
    changeTab(index) {
      this.activeTab = index
      this.viewState = ''
      this.getJinNangList()
    },
    riskSelect(item) {
      this.activeRisk = item.value
      this.viewState = ''
      this.getJinNangList()
    },
    styleSelect(item, index) {
      this.styleList.splice(index, 1, {
        ...item,
        selected: !item.selected
      })
      this.viewState = ''
      this.getJinNangList()
    },
    changeSortKey(item, index) {
      this.sortKeyList.splice(index, 1, {
        ...item,
        direction:
          item.direction === SortDirection.none ||
          item.direction === SortDirection.descending
            ? SortDirection.ascending
            : SortDirection.descending
      })

      this.activeSortKey = index
      this.viewState = ''
      this.getJinNangList()
    },
    async getJinNangList() {
      const sortKey = this.sortKeyList[this.activeSortKey]
      const style = this.styleList
        .filter(a => a.selected && a.value !== null)
        .map(a => a.value)
      const level = this.riskList.find(a => a.value === this.activeRisk).value
      const data = await getJinNangList(
        {
          sortKind: sortKey.type,
          orderBy: sortKey.direction,
          direction: this.viewState ? 2 : 0,
          styles: style.length === 0 ? null : style,
          levels: level === null ? null : [level]
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          const orignalViewState = this.viewState
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end

          if (data.detail.flush || orignalViewState === '') {
            this.jinNangList = data.detail.list
          } else {
            this.jinNangList = this.jinNangList.concat(data.detail.list)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-key-tabs {
  font-size: 12px;
  line-height: 52px;
  letter-spacing: 1px;
  color: #262626;
  display: flex;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;

  .sort-key-tab {
    cursor: pointer;
  }

  .sort-key-name {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
  }
}

.caret-wrapper {
  display: inline-flex;
  height: 34px;
  width: 24px;
  overflow: initial;
  position: relative;

  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;

    &.ascending {
      border-bottom-color: #c0c4cc;
      top: 5px;
    }

    &.descending {
      border-top-color: #c0c4cc;
      bottom: 7px;
    }

    .ascending &.ascending {
      border-bottom-color: #409eff;
    }

    .descending &.descending {
      border-top-color: #409eff;
    }
  }
}

.jinNang-list {
  flex: auto;
}

.jinNang-filter {
  flex: auto;
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.filter-row {
  flex: auto;
  align-items: center;
  display: flex;
  margin-bottom: 20px;
}

.filter-item {
  width: 72px;
  height: 26px;
  background-color: #f0f0f0;
  border-radius: 2px;
  margin-right: 20px;
  text-align: center;
  line-height: 26px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
}

.item-bottom-10 {
  margin-bottom: 10px;
}

.select-item {
  background-color: rgba($color: #046bcc, $alpha: 0.1);
  color: #046bcc;
}

.filter-row-type {
  flex: none;
  flex-basis: 80px;
  display: flex;
}

.filter-type-item {
  align-items: center;
  height: 14px;
  font-size: 14px;
  letter-spacing: 1px;
  color: #262626;
}

.filter-row-content {
  display: flex;
  align-items: center;
  align-content: space-between;
  flex-flow: row wrap;
}

.wrapper {
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
}

.content {
  flex: auto;
  display: flex;
  flex-direction: column;
}

.right-panel {
  margin-top: 30px;
  padding-left: 30px;
}
</style>
